module.exports = __webpack_public_path__ + "static/media/verset_2Tim2.481343f9.svg";